import { API, doGet, doPost, doPut, doDelete } from "@/api/api.js"
import axios from "axios"

export default {
    data: function () {
        return {
            exportChecked: [],
            exportMap: [],
            isExport: false,
            tag: "",          //如：AMDIN、ROLE
            handle: "",       //insert、update、delete
            isHandle: false,  //是否弹窗
            handleInfo: {},   //当前正在操作的信息（insert为{}，update、delete为当前操作项）
            current: 1,
            size: 10,
            total: 0,
            records: [],
            pageMap: [
                { code: "ACCESS", name: "访客信息", primaryColumn: "accessId" },
                { code: "POINT", name: "积分信息", primaryColumn: "pointId" },
                { code: "POINT_TYPE", name: "积分分类信息", primaryColumn: "pointTypeId" },
                { code: "ARTICLE", name: "文章信息", primaryColumn: "articleId" },
                { code: "MESSAGE", name: "用户消息", primaryColumn: "messageId" },
                { code: "BANNER", name: "Banner信息", primaryColumn: "bannerId" },
                { code: "NOTIFY", name: "系统通知", primaryColumn: "notifyId" },
                { code: "FAVOURITE_PRODUCT", name: "商品收藏", primaryColumn: "productFavouriteId" },
                { code: "FAVOURITE_ARTICLE", name: "文章收藏", primaryColumn: "articleFavouriteId" },
                { code: "ORDER", name: "订单信息", primaryColumn: "orderId" },
                { code: "PRODUCT", name: "课程信息", primaryColumn: "productId" },
                { code: "USER", name: "用户信息", primaryColumn: "userId" },
                { code: "ADMIN", name: "管理员", primaryColumn: "adminId", exportUrl: "/public/admin/export" },
                { code: "PERMISSION", name: "权限信息", primaryColumn: "permissionId", exportUrl: "/public/permission/export" },
                { code: "ROLE", name: "角色信息", primaryColumn: "roleId", exportUrl: "/public/role/export" },
                { code: "VIDEO", name: "视频信息", primaryColumn: "videoId", exportUrl: "/public/video/export" },
                { code: "TYPE", name: "课程分类", primaryColumn: "typeId", exportUrl: "/public/type/export" },
                { code: "COURSE", name: "课程详情", primaryColumn: "courseId" },
                { code: "COURSE_RECORD", name: "课程记录", primaryColumn: "courseRecordId" },
                { code: "QUESTION", name: "问题信息", primaryColumn: "questionId" },
                { code: "ANSWER", name: "答案信息", primaryColumn: "answerId" },
            ],
            filterParams: {}
        }
    },
    methods: {
        exportOpen: function () {
            this.isExport = true;
        },
        exportConfirm: function () {
            let exportParam = JSON.parse(JSON.stringify(this.filterParams));
            exportParam.exportList = [];
            for (let i = 0; i < this.exportMap.length; i++) {
                if (this.exportChecked.includes(this.exportMap[i].name)) {
                    exportParam.exportList.push(this.exportMap[i].value);
                }
            }
            axios.get(process.env.VUE_APP_BASE_API + this.pageMap.find(item => item.code === this.tag).exportUrl + "?" + (new URLSearchParams(exportParam)).toString(), { responseType: 'blob' })
                .then(response => {
                    this.isExport = false;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = (new Date()).getTime() + '.xlsx';
                    link.click();
                });
            // doGet(API.EXPORT.TICKET, this.filterParams);
        },
        sizeChange: function (size) {
            this.size = size;
            this.initialData();
        },
        currentChange: function (current) {
            this.current = current;
            this.initialData();
        },
        initialData: async function () {
            this.filterParams.current = this.current;
            this.filterParams.size = this.size;
            let datas = await doGet(API[this.tag], this.filterParams);
            if (datas) {
                this.records = datas.records;
                this.current = datas.current;
                this.size = datas.size;
                this.total = datas.total;
            }
            if (this.afterInitialData) {    //钩子函数，数据初始化后自动触发
                this.afterInitialData();
            }
        },
        getModalTitle: function () {
            let title = "";
            switch (this.handle) {
                case "insert": title = "新增"; break;
                case "update": title = "修改"; break;
                case "delete": title = "删除"; break;
            }
            title += this.pageMap.find(item => item.code === this.tag).name;
            return title;
        },
        handleClick: function (handle, info) {
            this.handle = handle;
            this.isHandle = true;
            if (info) {
                this.handleInfo = JSON.parse(JSON.stringify(info));
            }
            else {
                this.handleInfo = {};
            }
            if (this.beforeHandleOpen) {    //钩子函数，打开窗口后自动触发
                this.beforeHandleOpen(handle);
            }
            if (this.beforeHandleOpenEx) {    //钩子函数，打开窗口后自动触发
                this.beforeHandleOpenEx(handle, info);
            }
        },
        handleSubmit: async function () {
            let primaryColumn = this.pageMap.find(item => item.code === this.tag).primaryColumn;
            let resultObj;
            if (this.beforeHandleSubmit) {  //钩子函数，提交前自动触发
                this.beforeHandleSubmit();
            }
            switch (this.handle) {
                case "insert":
                    resultObj = await doPost(API[this.tag], this.handleInfo);
                    break;
                case "update":
                    resultObj = await doPut(API[this.tag], this.handleInfo);
                    break;
                case "delete":
                    resultObj = await doDelete(API[this.tag], this.handleInfo[primaryColumn]);
                    break;
                case "show":
                    this.isHandle = false;
                    return;
                    break;
            }
            if (this.afterHandleSubmit) {  //钩子函数，提交后自动触发
                this.afterHandleSubmit();
            }
            this.showResult(resultObj);
        },
        showResult: function (resultObj) {
            if (resultObj.errorCode == 0) {
                this.$message.success(resultObj.errorMessage);
                this.isHandle = false;
                this.loadData();
            }
            else {
                this.$message.error(resultObj.errorMessage);
            }
        },
        showResultEx: function (resultObj) {
            if (resultObj.errorCode == 0) {
                this.$message.success(resultObj.errorMessage);
            }
            else {
                this.$message.error(resultObj.errorMessage);
            }
        },
        convertToDate: function (unixTime) {
            if (unixTime) {
                const date = new Date(unixTime * 1000);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            }
            else {
                return "--";
            }
        },
        loadData: function (current) {
            if (current) {
                this.current = current;
            }
            //初始化参数
            if (this.initialParam) {
                this.initialParam();
            }
            //初始化数据
            if (this.getData) {     //若在组件/页面中存在getData方法，则执行getData方法，若不存在则执行默认的initialData方法
                this.getData();
            }
            else {
                this.initialData();
            }
            if (this.reloadData) {
                this.reloadData();
            }
        }
    },
    beforeMount: function () {
        this.loadData();
        try {
            this.exportMap = this.pageMap.find(item => item.code === this.tag).exportMap;
            this.exportChecked = [];
            for (let i = 0; i < this.exportMap.length; i++) {
                if (this.exportMap[i].checked) {
                    this.exportChecked.push(this.exportMap[i].name);
                }
            }
            console.log(this.exportMap);
        }
        catch (error) {
            console.log(error);
        }
    }
}